import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import urls from '../../../../networkRequests/apiClient/endpoints'
import errorHandler from '../../../../shared/functions/ErrorHandler/errorHandler.functions'
import { ApiErrorResponse } from '../../../../shared/types/api.types'
import { getUspsLocationsApi } from './getUspsLocations.api'
import getUspsLocationsInitialState from './getUspsLocations.initialState'
import { GetUspsLocationsErrorResponse, GetUspsLocationsRequestPayload } from './getUspsLocations.types'

export const getUspsLocations = createAsyncThunk(
  urls.usps.getLocations,
  async (payload: GetUspsLocationsRequestPayload, { rejectWithValue }) => {
    const { request, onSuccess } = payload

    try {
      const response = await getUspsLocationsApi(request)

      onSuccess?.(response)

      return response
    } catch (error) {
      errorHandler.handleApiError(error as ApiErrorResponse)

      return rejectWithValue(error)
    }
  }
)

const getUspsLocationsSlice = createSlice({
  name: urls.usps.getLocations,
  initialState: getUspsLocationsInitialState,
  reducers: {
    resetGetUspsLocations: (state) => {
      state.loading = false
      state.error = null
      state.success = null
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUspsLocations.pending, (state) => {
        state.loading = true
        state.error = null
        state.success = null
      })
      .addCase(getUspsLocations.fulfilled, (state, { payload }) => {
        state.loading = false
        state.success = payload
        state.error = null
      })
      .addCase(getUspsLocations.rejected, (state, { payload }) => {
        state.loading = false
        state.error = payload as GetUspsLocationsErrorResponse
        state.success = null
      })
  }
})

export const { actions: getUspsLocationsActions, reducer: getUspsLocationsReducer } = getUspsLocationsSlice
export const { resetGetUspsLocations } = getUspsLocationsActions
export default getUspsLocationsSlice.reducer
